<template>
  <div class="bg-[#FFF1EF] border-[1px] rounded-lg p-[14px] border-[#E2E2E2] relative">
    <div class="flex items-center justify-between gap-[16px]">
      <div class="flex items-center gap-[8px]">
        <div class="bg-[#FCD4BE] size-[28px] p-[4px] flex items-center justify-center rounded-lg">
          <img
            class="w-[16px] h-[16px]"
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/card-coin.svg"
          >
        </div>
        <h3 class="mb-0 font-medium text-[16px] text-[#333333]">
          Nominal Tagihan
        </h3>
      </div>
      <router-link
        :to="`/kompack/tagihan?start_date=${YEAR_MONTH_DAY(period.startDate)}&end_date=${YEAR_MONTH_DAY(period.endDate)}`"
        class="border-[1px] text-[12px] border-[#F95031] font-medium rounded py-[5px] px-[10px] flex items-center gap-2 hover:shadow"
      >Detail<span class="k-arrow-right-3 text-[18px] font-[600] ml-[10px]" />
      </router-link>
    </div>
    <div class="mt-[8px] mb-[16px]">
      <div>
        <b-skeleton
          v-if="loadingSummary"
          class="mt-[8px] mb-[16px]"
          width="85%"
          height="38px"
        />
        <p
          v-else
          class="text-[36px] font-semibold text-[#333333] leading-[38px] mb-[16px] flex items-center gap-[8px] flex-wrap"
        >
          {{ IDR(summary.nominal_invoice_this_month) }}
        </p>
      </div>
      <p class="text-[#626262] text-[10px]">
        Bulan lalu : {{ IDR(summary.nominal_invoice_last_month) }}
      </p>
    </div>
    <div class="flex gap-[16px] flex-wrap z-[1] relative">
      <div class="border-[1px] border-[#E2E2E2] bg-white px-[14px] pt-[8px] pb-[16px] rounded-lg grow">
        <div class="flex gap-[10px] items-center mb-[8px]">
          <h3 class="mb-0 text-[12px] text-[#626262] font-normal">
            Jumlah Invoice yang Tertagih
          </h3>
        </div>
        <div>
          <b-skeleton
            v-if="loadingSummary"
            class="!mb-[6px]"
            width="85%"
            height="22px"
          />
          <p
            v-else
            class="text-[20px] font-semibold text-[#333333] leading-[20px] mb-[8px] flex items-center gap-[8px] flex-wrap"
          >
            {{ summary.number_of_bill_this_month }}
          </p>
        </div>
        <p class="text-[#828282] text-[10px] mb-0">
          Bulan lalu : <span class="text-[#333333]">{{ summary.number_of_bill_last_month }}</span>
        </p>
      </div>
      <div class="border-[1px] border-[#E2E2E2] bg-white px-[14px] pt-[8px] pb-[16px] rounded-lg grow">
        <div class="flex gap-[10px] items-center mb-[8px]">
          <h3 class="mb-0 text-[12px] text-[#626262] font-normal">
            Jumlah Invoice Lunas
          </h3>
        </div>
        <div>
          <b-skeleton
            v-if="loadingSummary"
            class="!mb-[6px]"
            width="85%"
            height="22px"
          />
          <p
            v-else
            class="text-[20px] font-semibold text-[#333333] leading-[20px] mb-[8px] flex items-center gap-[8px] flex-wrap"
          >
            {{ summary.number_of_bill_paid_this_month }}
          </p>
        </div>
        <p class="text-[#828282] text-[10px] mb-0">
          Bulan lalu : <span class="text-[#333333]">{{ summary.number_of_bill_paid_last_month }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'
import { YEAR_MONTH_DAY } from '@/libs/filterDate'

export default {
  props: {
    period: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingSummary: true,
      summary: {},
    }
  },
  watch: {
    period: {
      handler() {
        this.fetchSummary()
      },
    },
  },
  mounted() {
    this.fetchSummary()
  },
  methods: {
    IDR,
    YEAR_MONTH_DAY,
    fetchSummary() {
      this.loadingSummary = true
      this.$http_new.get('/auth/api/v1/admin/user-balance-invoices/summaries', {
        params: {
          start_date: YEAR_MONTH_DAY(this.period.startDate),
          end_date: YEAR_MONTH_DAY(this.period.endDate),
        },
      }).then(res => {
        this.summary = res.data.data
      }).catch(err => {
        this.summary = {
          nominal_invoice_this_month: 0,
          nominal_invoice_paid_this_month: 0,
          nominal_invoice_last_month: 0,
          nominal_invoice_paid_last_month: 0,
          number_of_bill_this_month: 0,
          number_of_bill_paid_this_month: 0,
          number_of_bill_last_month: 0,
          number_of_bill_paid_last_month: 0,
        }
        this.$toast_error({
          message: 'Gagal mengambil data tagihan, silahkan coba lagi',
        })
      }).finally(() => {
        this.loadingSummary = false
      })
    },
  },
}

</script>

<style scoped>

</style>
